import { SkyText } from "@skypointcloud/skypoint-ui";
import { useDisplayTz } from "@/hooks/use-display-tz";
import { zoneCaption } from "@/lib/time/displayTime";

/**
 * "Times in India (IST)", said once under or over a grid of instants (round 3, 2026-09-30): the
 * grid's headers no longer carry a zone, and its times are the reader's display zone
 * (`useDisplayTz`). A time that stands alone names its zone itself (`formatInstant`'s `named`).
 */
export function ZoneCaption({ testId, className }: { testId: string; className?: string }) {
  const zone = useDisplayTz();
  return (
    <SkyText size={200} color="muted" block className={className} testId={testId}>
      {zoneCaption(zone)}
    </SkyText>
  );
}
